export default __webpack_public_path__ + "static/media/Book10.eb8e73f7.pdf";